import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { COMFORT_STATEMENTS, beliefQuote } from "@/lib/gatewayContent";
import SanctuaryHeader from "@/components/gateway/SanctuaryHeader";
import { X } from "lucide-react";

const Emptiness = () => {
  const navigate = useNavigate();
  const { user } = useAuth();
  const [message, setMessage] = useState("");
  const [quote] = useState(() => beliefQuote(user?.belief_filter));
  const intervalRef = useRef(null);

  // Grounding heartbeat haptic loop (lub-dub) — works where the Vibration API is supported
  useEffect(() => {
    const beat = () => { if (navigator.vibrate) navigator.vibrate([90, 120, 90, 900]); };
    beat();
    intervalRef.current = setInterval(beat, 1400);
    return () => { clearInterval(intervalRef.current); if (navigator.vibrate) navigator.vibrate(0); };
  }, []);

  const iAmHere = () => {
    const next = COMFORT_STATEMENTS[Math.floor(Math.random() * COMFORT_STATEMENTS.length)];
    setMessage(next);
    if (navigator.vibrate) navigator.vibrate(60);
  };

  return (
    <div className="min-h-screen bg-black flex flex-col items-center justify-center px-8 relative" data-testid="emptiness-screen">
      <SanctuaryHeader tone="dark" className="absolute top-5 left-5 z-20" />
      <button onClick={() => navigate("/gateway")} data-testid="emptiness-exit" className="absolute top-5 right-5 text-white/25 hover:text-white/60 transition-colors">
        <X className="w-6 h-6" />
      </button>

      {message && (
        <p className="text-white/70 font-light text-xl leading-relaxed text-center max-w-md mb-16 animate-fade-up" data-testid="comfort-statement">
          {message}
        </p>
      )}

      <button onClick={iAmHere} data-testid="im-here-button"
        className="w-44 h-44 rounded-full text-white/90 font-serif text-2xl tracking-wide animate-breathe transition-transform active:scale-95"
        style={{ background: "radial-gradient(circle at 50% 40%, rgba(212,224,217,0.35), rgba(44,74,59,0.25))", boxShadow: "0 0 60px 10px rgba(160,200,180,0.15)", animationDuration: "5s" }}>
        I'm Here
      </button>

      <p className="text-white/25 text-sm mt-16 font-light">Tap whenever you need to feel less alone</p>
      <p className="absolute bottom-6 left-0 right-0 text-center text-white/20 text-xs px-8 font-light">{quote}</p>
    </div>
  );
};

export default Emptiness;
